module.exports = __webpack_public_path__ + "static/media/ceat.756ea86b.svg";